import React from "react";
import validator from "validator";

export const required = (value, props) => {
  if (!value.toString().trim().length) {
    // We can return string or jsx as the 'error' prop for the validated Component
    if (props.label) {
      return <span className="require_field">{props.label} is Required</span>;
    } else {
      return <span className="require_field">Required</span>;
    }
  }
};

export const filesize = allwedSize => (value, props) => {
  if (props.fileSize > allwedSize) {
    // We can return string or jsx as the 'error' prop for the validated Component

    return (
      <span className="require_field">
        File size more then {allwedSize / 1024} kb not allwed
      </span>
    );
  }
};

export const requiredCheck = (value, props) => {
  if (!value || (props.isCheckable && !props.checked)) {
    return <span className="require_field is-visible">Required</span>;
  }
};

export const requiredSelect = (value, props) => {
  if (parseInt(value, 10) === 0) {
    // We can return string or jsx as the 'error' prop for the validated Component
    if (props.label) {
      return <span className="require_field">{props.label} is Required</span>;
    } else {
      return <span className="require_field">Required</span>;
    }
  }
};

export const email = value => {
  if (!validator.isEmail(value)) {
    return <span className="require_field">{value} is not a valid email.</span>;
  }
};

export const minLength = (value, props) => {
  if (value.length !== 10) {
    return (
      <span className="require_field">{props.label} Must be 10 digits.</span>
    );
  }
};

export const lt = (value, props) => {
  // get the maxLength from component's props
  if (!value.toString().trim().length > props.maxLength) {
    // Return jsx
    return (
      <span className="require_field">
        The value exceeded {props.maxLength} symbols.
      </span>
    );
  }
};

export const password = (value, props, components) => {
  // NOTE: Tricky place. The 'value' argument is always current component's value.
  // So in case we're 'changing' let's say 'password' component - we'll compare it's value with 'confirm' value.
  // But if we're changing 'confirm' component - the condition will always be true
  // If we need to always compare own values - replace 'value' with components.password[0].value and make some magic with error rendering.
  if (value !== components["confirm"][0].value) {
    // components['password'][0].value !== components['confirm'][0].value
    // 'confirm' - name of input
    // components['confirm'] - array of same-name components because of checkboxes and radios
    return <span className="require_field">Passwords are not equal.</span>;
  }
};

export const isEqual = (value, props, components) => {
  /*
  <div className="small-12 medium-6 columns">
            <label>
              Password*
              <Input
                placeholder="Password"
                type="password"
                name="password"
                validations={[required, isEqual]}
              />
            </label>
          </div>
          <div className="small-12 medium-6 columns">
            <label>
              Confirm password*
              <Input
                placeholder="Confirm password"
                type="password"
                name="confirm"
                validations={[required, isEqual]}
              />
            </label>
          </div>
  */
  const bothUsed =
    components.password[0].isUsed && components.confirm[0].isUsed;
  const bothChanged =
    components.password[0].isChanged && components.confirm[0].isChanged;

  if (
    bothChanged &&
    bothUsed &&
    components.password[0].value !== components.confirm[0].value
  ) {
    return (
      <span className="form-error is-visible require_field">
        Passwords are not equal.
      </span>
    );
  }
};

export const selectAdvance = value => {
  console.log(value);
};



// WEBPACK FOOTER //
// ./src/components/lib/validations.js